import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Moment from "react-moment";
import moment from "moment";
import { Modal, Collapse } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Spinner from "../component/Spinner";
import AlertErrorForm from "../component/AlertErrorForm";
import DateTimePicker from "react-datetime-picker";
import RoomsSelect from "../component/RoomsSelect";
import MetaRooms from "../component/MetaRooms";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function DanhSachDatPhongHop() {
  let query = useQuery();
  const { user } = useSelector((state) => state.auth);
  const { notification } = useSelector((state) => state.save);
  const { bookingstatus } = useSelector((state) => state.save);

  const [rooms, setRooms] = useState([])
  const [listDay, setListday] = useState([])
  const today = query.get("date") ? new Date(query.get("date")) : new Date()
  const [showModal, setShowModal] = useState(false)
  const [refreshPage, setRefreshPage] = useState(false)
  const [detailActive, setDetailActive] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingCar, setLoadingCar] = useState(false)
  const weekdays = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', '7'];
  const dateNow = new Date();
  const backDate = new Date(dateNow.setDate(dateNow.getDate()))
  const [dateSelect, setDateSelect] = useState({ datestart: "", dateend: "" })
  const [openStates, setOpenStates] = useState({});
  const [timeSlots, setTimeSlots] = useState([]);

  const pickerRef = useRef(null);

  const toggleCollapse = (addressname) => {
    setOpenStates(prev => ({
      ...prev,
      [addressname]: !prev[addressname]
    }));
  };

  useEffect(function () {
    const dates = [];
    for (let i = -3; i <= 3; i++) {
      const newDate = new Date(today);
      newDate.setDate(today.getDate() + i);
      const dayOfWeek = weekdays[newDate.getDay()];
      const day = `${newDate.getDate()}/${newDate.getMonth() + 1}`;
      const isToday =
        newDate.getDate() === today.getDate() &&
        newDate.getMonth() === today.getMonth() &&
        newDate.getFullYear() === today.getFullYear();
      const formatted = {
        dayOfWeek: dayOfWeek,
        day: day,
        active: isToday ? 1 : 0,
        dateObject: newDate,
      };
      dates.push(formatted);
    }
    setListday(dates)
  }, [])

  useEffect(function () {
    if (notification && notification.action && notification.action == 'room_booking' && notification.datebooking == moment(new Date(today)).format('YYYY-MM-DD')) {
      setRefreshPage(!refreshPage)
    }
  }, [notification])

  useEffect(function () {
    setLoadingCar(true)
    Axios.get(URL_LIST_ALL + "rooms?status=1&orderby=id-ASC&date=" + today.toISOString().split('T')[0], user.config)
      .then(async (res) => {
        setLoadingCar(false)
        if (res.data.status == "success") {
          let detail = res.data
          let subrooms = detail.subrooms
          setRooms(subrooms);
        } else console.log(res.data.message);
      })
      .catch((err) => { console.log(err); setLoadingCar(false) });
  }, [refreshPage])

  const getTimeNow = () => {
    const now = new Date();
    return Math.floor(now.getTime() / 60000);
  };

  const formik = useFormik({
    initialValues: { title: '', timestart: null, datestart: "", timeend: null, aprover_id: '', dateend: "", support_id: '', room_id: 0, room_note: "", user_id: user.data.id,status:1 },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().nullable().required('Nhập nội dung').max(150, "Độ dài không quá 150 ký tự"),
      timestart: Yup.string().trim().nullable().required('Chọn thời gian bắt đầu'),
      timeend: Yup.string().trim().nullable().required('Chọn thời gian kết thúc'),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      values.dateend = values.datestart
      if (values.support_id) {
        values.support_id = parseInt(values.support_id)
      }
      let checker = 0
      if (parseTime(values.timestart, values.datestart) < parseTime(values.timeend, values.dateend)) {
        if (values.id) {
          if (getTimeNow() <= parseTime(values.timeend, values.dateend)) {
            checker = 1
          } else {
            alert("Giờ kết thúc không được nhỏ hơn giờ hiện tại")
          }
        } else {
          if (getTimeNow() <= parseTime(values.timestart, values.datestart)
            && getTimeNow() <= parseTime(values.timeend, values.dateend)) {
            checker = 1
          } else {
            alert("Giờ bắt đầu không được nhỏ hơn giờ hiện tại")
          }
        }
      } else {
        alert("Giờ bắt đầu không được lớn hơn giờ kết thúc")
      }

      if (checker == 1) {
        setLoading(true)
        if (values.id) {
          Axios.put(URL_LIST_ALL + 'room_booking/' + values.id, values, user.config).then(res => {
            if (res.data.status == "success") {
              setLoading(false)
              setShowModal(false)
              alert("Sửa lịch phòng họp thành công")
              formik.resetForm()
              setRefreshPage(!refreshPage)
            } else {
              alert(res.data.message)
            }
          }).catch(err => {
            console.log(err)
            setLoading(false)
          });
        } else {
          Axios.post(URL_LIST_ALL + 'room_booking', values, user.config).then(res => {
            setLoading(false)
            if (res.data.status == "success") {
              setShowModal(false)
              alert("Đặt phòng họp thành công")
              formik.resetForm()
              setRefreshPage(!refreshPage)
            } else {
              alert(res.data.message)
            }
          }).catch(err => {
            console.log(err)
            setLoading(false)
          });
        }
        setSubmitting(false)

      }
    },
  });

  const handleDate = (name, value) => {
    formik.setFieldValue(name, moment(value).format('YYYY-MM-DD'))
    formik.setFieldTouched(name)
    let newDate = Object.assign({}, dateSelect)
    newDate[name] = value
    setDateSelect(newDate)

  };

  useEffect(() => {
    if (Object.keys(rooms).length > 0) {
      const firstKey = Object.keys(rooms)[0];
      setOpenStates({ [firstKey]: true });
    }
  }, [rooms]);

  useEffect(() => {
    if (!showModal) {
      formik.resetForm()
      setDateSelect({ datestart: "" })
    }

  }, [showModal]);

  const showEditBooking = (detail) => {
    let datestart = detail.datestart
    let dateend = detail.dateend
    formik.setFieldValue('title', detail.title)
    formik.setFieldValue('id', detail.id)
    formik.setFieldValue('room_id', detail.room_id)
    formik.setFieldValue('timestart', moment(new Date(datestart * 1000)).format('HH:mm'))
    formik.setFieldValue('timeend', moment(new Date(dateend * 1000)).format('HH:mm'))
    formik.setFieldValue('datestart', moment(new Date(datestart * 1000)).format('YYYY-MM-DD'))
    formik.setFieldValue('meta', detail.meta ? detail.meta : [])
    formik.setFieldValue('room_note', detail.room_note)
    formik.setFieldValue('user_id', detail.user_id)
    formik.setFieldValue('aprover_id', detail.aprover_id)
    setDateSelect({ datestart: datestart * 1000, dateend: dateend * 1000 })
    setShowModal(true)
  }

  const actionBooking = (item) => {
    setShowModal(!showModal);
    setDetailActive(item);
    formik.resetForm();
    formik.setFieldValue('room_id', item.id)
    formik.setFieldValue('aprover_id', item.aprover_id)
    setDateSelect({ datestart: today })
    formik.setFieldValue('datestart', moment(today).format('YYYY-MM-DD'))
  }

  const parseTime = (timeStr, dateStr) => {
    const dateTime = new Date(`${dateStr}T${timeStr}`);
    return Math.floor(dateTime.getTime() / 60000);
  }

  useEffect(() => {
    if (bookingstatus?.data) {
      // console.log(bookingstatus.data);
      const updatedSlots = timeSlots.map(slot => {
        if (bookingstatus.data.includes(slot.booking_id)) {
          return { ...slot, status: 'busy' };
        }
        return slot;
      });
      setTimeSlots(updatedSlots);
    }
  }, [bookingstatus]);

  const checkStatus = (data, id) => {
    if (data && data[id]) {
      return <span className="status busy"><i></i></span>
    }
    return <span className="status"><i></i></span>
  }
  const checkStatusItem = (data, room_id, id) => {
    if (data && data[room_id] && data[room_id] == id) {
      return <span className="status busy"><i></i></span>
    }
    return ''
  }

  const Delete = (id) => {
    confirmAlert({
      title: 'Cảnh báo',
      message: 'Bạn có chắc chắn hủy lịch đặt phòng này?',
      buttons: [{
        label: 'OK', onClick: () => {
          Axios.put(URL_LIST_ALL + 'room_booking/' + id,{status:2}, user.config).then(res => {
            if (res.data.status == "success") {
              setRefreshPage(!refreshPage)
            } else alert(res.data.message);
          }).catch(err => console.log(err));
        },
      }]
    });
  }

  return (<AkkhorLayout idrole="dashboard">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Đặt phòng họp
        </li>
      </ul>
    </div>
    <div className="w-100 d-flex justify-content-center">
      <div className="listday">
        {listDay ? listDay.map((item, i) => {
          return <a href={"/dat-phong-hop?date=" + moment(new Date(item.dateObject)).format('YYYY-MM-DD')} 
          className={"item-day rounded border shadow-sm mb-2 " + (item.active ? "bg-warning" : (moment(new Date(item.dateObject)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD') ? " bg-info" : ""))} key={i}>
            <span>{item.dayOfWeek} <br /> {item.day}</span>
          </a>
        }) : ''}
        <button type="button" className="item-day rounded border shadow-sm" onClick={() => pickerRef.current.openCalendar()}><i className="fas fa-calendar-alt"></i></button>
        <DateTimePicker onChange={(value) => { window.location.href = "/dat-phong-hop?date="+ moment(new Date(value)).format('YYYY-MM-DD') }} value={today} format="dd-MM-y" className="air-datepicker" disableClock={true}
          hourPlaceholder="giờ" minutePlaceholder="phút" secondPlaceholder="giây" yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" ref={pickerRef}></DateTimePicker>
      </div>
    </div>

    {loadingCar ? <div className="w-100 d-flex justify-content-center mt-3 mb-3"><Spinner /></div> : null}

    <div className="listcar mt-5">

      {Object.keys(rooms).map((addressname, i) => {
        let listRoom = rooms[addressname];
        // const isOpen = openStates[addressname] || false;
        const isOpen = true;

        return (
          <div className="accordioncontent address-item mb-3" key={i}>
            <div className="card">
              <div className="card-header cursor-pointer" onClick={() => toggleCollapse(addressname)}>
                {addressname}
                <i className={"fas float-right " + (isOpen ? "fa-angle-up" : "fa-angle-down")}></i>
              </div>

              <Collapse in={isOpen} className="card-body">
                <div className="row mt-2">
                  {listRoom.map((item, j) => {
                    return (
                      <div className="col-12 col-sm-4 car-item mb-3" key={j}>
                        <div className="car-wrapper rounded border shadow-sm">
                          <h5 className="w-100 text-center pt-2 pb-2">
                            {item.title} <br /> <small>{item.soghe}</small>
                            
                            {bookingstatus && bookingstatus.data ? checkStatus(bookingstatus.data, item.id) : (item.bookingstatus && Object.keys(item.bookingstatus).length > 0 ? checkStatus(item.bookingstatus, item.id) : <span className="status"><i></i></span>)}
                          </h5>
                          <div className="timeline p-3">
                            {item.listtime && item.listtime.map(function (booking, j) {
                              let time_start = new Date(booking.datestart * 1000);
                              let time_end = new Date(booking.dateend * 1000);
                              let datefomatstart = moment(time_start).format('DD/MM/YYYY')
                              let datefomatend = moment(time_end).format('DD/MM/YYYY')

                              return <div className={"item-booking border shadow-sm pl-2 pr-2 " + (j != 0 ? 'mt-3' : '')} key={j}>
                                <div className="row">
                                  <div className="col-12 col-sm-5 d-flex align-items-center left pt-2 pb-2">
                                    <div className="insite w-100">
                                      {datefomatstart == datefomatend ?
                                        <><Moment format="HH:mm">{time_start}</Moment> <span className="fas fa-arrow-right text-danger"></span> <Moment format="HH:mm">{time_end}</Moment> <br />{datefomatstart}</>
                                        :
                                        <>
                                          <div className="w-100 d-flex justify-content-center">
                                            <Moment format="HH:mm D/M/YYYY">{time_start}</Moment>
                                          </div>
                                          <div className="w-100 d-flex justify-content-center">
                                            <span className="far fa-clock text-info"></span>
                                            <span className="far fa-arrow-alt-circle-down text-danger"></span>
                                          </div>
                                          <div className="w-100 d-flex justify-content-center">
                                            <Moment format="HH:mm D/M/YYYY">{time_end}</Moment>
                                          </div>
                                        </>
                                      }
                                      {
                                      (new Date(today).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)) && 
                                      ((user.data.id == item.aprover_id || user.data.id == booking.user_id)) && (user.data.id == item.aprover_id || time_start >= new Date() ) &&  time_end > new Date()?
                                                
                                        <div className="action mt-2">
                                          <button className="btn btn-sm btn-warning text-warning" type="button" title="Sửa" onClick={() => { showEditBooking(booking); setDetailActive(item) }}>
                                            <i className="far fa-edit"></i>
                                          </button>
                                    
                                          <button className="btn btn-sm btn-danger text-danger ml-2" type="button" title="Xóa" onClick={() => Delete(booking.id)}>
                                            <i className="far fa-trash-alt"></i>
                                          </button>
                                            
                                        </div>
                                        : ''
                                      
                                      }
                                    </div>
                                  </div>
                                  <div className="col-12 col-sm-7 right border-left-sm pt-2 pb-2">
                                    <div className="w-100 mb-2"><i className="fas fa-solar-panel text-success"></i> {booking.title}</div>
                                    <div className="w-100 mb-2 booker-name position-relative">
                                      <div className="cursor-pointer"><i className="fas fa-user-tag text-success"></i> {booking.booker_name} <i className="far fa-eye text-warning"></i></div>
                                      <div className="booker_info">
                                        <div className="wrapper border shadow-sm">
                                          <p>Người đặt: <strong>{booking.booker_name}</strong></p>
                                          <p>Phòng ban: <strong>{booking.phongban}</strong></p>
                                          <p>Công ty: <strong>{booking.congty}</strong></p>
                                          <p>Email: <strong>{booking.booker_mail}</strong></p>
                                        </div>
                                      </div>
                                    </div>
                                    {booking.list_meta && Array.isArray(booking.list_meta) && booking.list_meta.length > 0 ?
                                      <div className="w-100 mb-2">
                                        <i className="fas fa-angle-right text-danger"></i> {booking.list_meta.join(', ')}</div> :
                                      ''}
                                    {booking.support_id ?
                                      <div className="w-100 mb-2 booker-name position-relative">
                                        <div className="cursor-pointer"><i className="fas fa-users-cog text-success"></i> {booking.support_name} <i className="far fa-eye text-warning"></i></div>
                                        <div className="booker_info">
                                          <div className="wrapper border shadow-sm">
                                            <p>Hỗ trợ kỹ thuật: <strong>{booking.support_name}</strong></p>
                                            <p>Phòng ban: <strong>{booking.support_part}</strong></p>
                                            <p>Công ty: <strong>{booking.support_company}</strong></p>
                                            <p>Email: <strong>{booking.support_mail}</strong></p>
                                          </div>
                                        </div>
                                      </div>
                                      : ''}
                                    {booking.room_note ? <div className="w-100 mb-2"><i className="fas fa-angle-right text-danger"></i> <small>Ghi chú: {booking.room_note}</small></div> : ''}
                                    {bookingstatus && bookingstatus.data ? checkStatusItem(bookingstatus.data, item.id, booking.id) : checkStatusItem(item.bookingstatus, item.id, booking.id)}
                                  </div>
                                </div>
                              </div>
                            })}
                          </div>
                          {(new Date(today)).setHours(0, 0, 0, 0) >= (new Date()).setHours(0, 0, 0, 0) &&
                            <div className="w-100 d-flex justify-content-center pt-2 pb-2">
                              <button type="button" className="btn btn-sm btn-success pl-5 pr-5" onClick={() => { actionBooking(item) }}>Đặt phòng</button>
                            </div>
                          }

                        </div>
                      </div>
                    )
                  })}
                </div>
              </Collapse>
            </div>
          </div>
        );
      })}
    </div>

    <Modal show={showModal} onHide={() => setShowModal(false)} animation={true} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Đặt phòng họp: {detailActive ? <strong>{detailActive.title}</strong> : null}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="new-added-form form-room" method="post" onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-12 form-group">
              <label>Nội dung đặt phòng họp <span className="text-danger">*</span></label>
              <input type="text" placeholder="VD: Họp với đối tác" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
              <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
            </div>
            <div className="col-12 form-group">
              <label>Chọn phòng</label>
              <RoomsSelect onChange={(e) => formik.setFieldValue('room_id', e.value)} defaultvalue={detailActive ? detailActive : new Date()} />
            </div>
            <div className="col-sm-4 col-12 form-group">
              <label>Giờ bắt đầu: <span className="text-danger">*</span></label>
              {/* <input type="time" step="300" lang="en-GB" placeholder="Thời gian" className="form-control height32" {...formik.getFieldProps("timestart")} /> */}
              <Flatpickr
                data-enable-time
                noCalendar
                options={{ enableTime: true, noCalendar: true, dateFormat: "H:i", time_24hr: true, allowInput: true, clickOpens: false }}
                className="form-control height32"
                value={
                  formik.values['timestart']
                    ? moment(formik.values['timestart'], "HH:mm").toDate() // chuyển string về Date object
                    : null
                }
                onChange={([date]) => formik.setFieldValue('timestart', moment(date).format("HH:mm"))}
              />
              <AlertErrorForm formik={formik} name="timestart"></AlertErrorForm>
            </div>
            <div className="col-sm-4 col-12 form-group">
              <label>Giờ kết thúc: <span className="text-danger">*</span></label>
              {/* <input type="time" step="300" lang="en-GB" placeholder="Thời gian" className="form-control height32" {...formik.getFieldProps("timeend")} /> */}
              <Flatpickr
                data-enable-time
                noCalendar
                options={{ enableTime: true, noCalendar: true, dateFormat: "H:i", time_24hr: true, allowInput: true, clickOpens: false }}
                className="form-control height32"
                value={
                  formik.values['timeend']
                    ? moment(formik.values['timeend'], "HH:mm").toDate() // chuyển string về Date object
                    : null
                }
                onChange={([date]) => formik.setFieldValue('timeend', moment(date).format("HH:mm"))}
              />
              <AlertErrorForm formik={formik} name="timeend"></AlertErrorForm>
            </div>
            <div className="col-sm-4 col-12 form-group">
              <label>Ngày: <span className="text-danger">*</span></label>
              <DateTimePicker onChange={(value) => { handleDate('datestart', value) }} value={dateSelect.datestart ? new Date(dateSelect.datestart) : null} format="dd-MM-y" className="form-control height32 air-datepicker" disableClock={true}
                hourPlaceholder="giờ" minutePlaceholder="phút" secondPlaceholder="giây" yearPlaceholder="Năm" monthPlaceholder="Tháng" dayPlaceholder="Ngày" minDate={backDate}></DateTimePicker>
              <AlertErrorForm formik={formik} name="datestart"></AlertErrorForm>
            </div>

            <div className="col-sm-4 col-12 form-group">
              <label>Hỗ trợ kỹ thuật: </label>
              <select className="form-select height32" {...formik.getFieldProps("support_id")}>
                <option value="0">Không cần hỗ trợ</option>
                <option value={detailActive ? detailActive.support_id : 0}>Cần hỗ trợ</option>
              </select>
            </div>
            <div className="col-12 form-group">
              <label>Danh sách cần chuẩn bị: </label>
              <MetaRooms defaults={formik.values['meta']} onChange={(newValues) => formik.setFieldValue('meta', newValues)} />
            </div>
            <div className="col-12 form-group">
              <label>Ghi chú: </label>
              <textarea placeholder="Ghi chú" className="form-control" {...formik.getFieldProps("room_note")} style={{ minHeight: "95px" }}></textarea>
            </div>
            <div className="col-12 form-group mt-3 d-flex justify-content-center">
              <button type="button" onClick={() => formik.submitForm()} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu</>}</button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  </AkkhorLayout>);
}
